// @flow
import type { Booking } from 'types/bookings';

import React, { Component } from 'react';

import { entityURLForCohort } from 'utils/cohort-utils';
import { bookingStateString } from 'utils/booking-utils';
import withEscapeToDismiss from 'components/others/WithEscapeToDismiss';

import './BookingDetailsPanel.scss';

type Props = {
  booking: Booking,
  handleClose: Function,
};

/* eslint-disable react/prefer-stateless-function */
@withEscapeToDismiss()
export default class BookingDetailsPanel extends Component {
  props: Props;

  render() {
    const booking: Booking = this.props.booking;
    return (
      <div className="booking-details-panel">
        <button
          aria-label="Close"
          className="is-pulled-right delete close-icon"
          onClick={() => {
            this.props.handleClose();
          }}
        />
        <h3 className="title is-6">
          <strong>{booking.bookingID}{' '}
            <a
              href={`${entityURLForCohort()}/bookings/${booking.bookingID}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="icon is-small">
                <i className="fa fa-external-link" />
              </span>
            </a>
          </strong>
        </h3>
        <table className="table is-narrow">
          <tbody>
            {booking.state != null &&
              <tr>
                <td>State</td>
                <td>
                  <span className="tag is-small">{bookingStateString(booking.state)}</span>
                </td>
              </tr>
            }
            {booking.passengerID &&
              <tr>
                <td>Passenger ID</td>
                <td>{booking.passengerID}</td>
              </tr>
            }
            {booking.driverID &&
              <tr>
                <td>Driver ID</td>
                <td>{booking.driverID}</td>
              </tr>
            }
            {booking.taxiTypeName &&
              <tr>
                <td>Taxi Type</td>
                <td>{booking.taxiTypeName}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/views/dashboard/bookings/BookingDetailsPanel.jsx
 **/